import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'

const NavigationMenu: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const menuLinks = [
    { to: '/videos', label: 'Video Library' },
    // { to: '/pricing', label: 'Pricing' },
    { to: '/about', label: 'About' },
    { to: '/terms-of-service', label: 'Terms of Service' },
    { to: '/data-processing-addendum', label: 'Data Processing Addendum' },
  ]

  return (
    <>
      <button
        onClick={() => setIsMenuOpen(true)}
        className="p-2 text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-md"
        aria-label="Open menu"
      >
        <Bars3Icon className="w-6 h-6" />
      </button>

      {/* Overlay */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity"
          onClick={() => setIsMenuOpen(false)}
        />
      )}

      {/* Side Menu Drawer */}
      <div
        className={`fixed top-0 right-0 h-full bg-white shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
        style={{ minWidth: '350px', width: '350px' }}
      >
        <div className="flex flex-col h-full">
          {/* Menu Header */}
          <div className="flex justify-between items-center p-6 border-b border-gray-200">
            <h2 className="text-xl font-bold text-gray-900">Menu</h2>
            <button
              onClick={() => setIsMenuOpen(false)}
              className="p-2 text-gray-600 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-md"
              aria-label="Close menu"
            >
              <XMarkIcon className="w-6 h-6" />
            </button>
          </div>

          {/* Menu Links */}
          <nav className="flex-1 overflow-y-auto p-6">
            <ul className="space-y-4">
              <li key="request-demo">
                <Link
                  to="/request-demo"
                  onClick={() => setIsMenuOpen(false)}
                  className="block px-4 py-3 hover:text-blue-100 hover:bg-blue-700 bg-blue-600 text-white rounded-md transition-colors font-medium"
                >
                  Request a Demo
                </Link>
              </li>
              {menuLinks.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    onClick={() => setIsMenuOpen(false)}
                    className="block px-4 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 rounded-md transition-colors font-medium"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* Menu Footer */}
          <div className="p-6 border-t border-gray-200">
            <Link
              to="/privacy-policy"
              onClick={() => setIsMenuOpen(false)}
              className="block text-sm text-gray-500 hover:text-gray-700 mb-2"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}

export default NavigationMenu
